
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {
		periodo: 'previsao',
		data_inicial: DateFormat.getDataAnterior(30),
		data_final: DateFormat.getDataAtual()
	},
	lista: [],
	listaMotorista: [],
	listaTipo: [],
	listaEstado: [],
	listaPlaca: [],
	listaLevas: [{ id: 1, valor: 'Leva' }, { id: 2, valor: 'Troca' }],
	listaEstadoTrocas: [],
	listaCidadeTroca: [],
	listaEmails: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MOTORISTA_FOLGA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'MOTORISTA_FOLGA_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'MOTORISTA_FOLGA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'MOTORISTA_FOLGA_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome
				}))
			};
		
		case 'MOTORISTA_FOLGA_MOTORISTA_SELECT_LISTADO':
            return {
				...state,
				listaMotorista: action.payload.data
			};

		case 'MOTORISTA_FOLGA_TIPO_SELECT_LISTADO':
            return {
				...state,
				listaTipo: action.payload.data
			};

		case 'MOTORISTA_FOLGA_ESTADO_SELECT_LISTADO':
            return {
				...state,
				listaEstado: action.payload.data
			};

		case 'MOTORISTA_FOLGA_PLACA_SELECT_LISTADO':
			return {
				...state,
				listaPlaca: action.payload.data
			};

		case 'MOTORISTA_FOLGA_ESTADO_TROCA_SELECT_LISTADO':
            return {
				...state,
				listaEstadoTrocas: action.payload.data
			};

		case 'MOTORISTA_FOLGA_CIDADE_TROCA_SELECT_LISTADO':
            return {
				...state,
				listaCidadeTroca: action.payload.data
			};
		
		case 'MOTORISTA_FOLGA_EMAIL_LISTADO':
			return {
				...state,
				listaEmails: action.payload.data
			};

        default:
            return state;
    }
}
